import { api } from './apiProvider';

export interface PaymentMethodListItem {
  id: string;
  paymentType: string;
  last4: string;
  accountBrand: string;
  expiration: string;
  autopay: boolean;
  cardFunding: string;

  [key: string]: string | number | Date | boolean;
}

export interface PaymentMethodExistsResponse {
  isAutopay: boolean;
  exists: boolean;
}

export interface AutopayToggleRequest {
  paymentMethodId: string;
  isAutopay: boolean;
}

export interface MethodIntentUpdateRequest {
  setupIntentId: string;
  isAutopay: boolean;
  paymentMethodId?: string;
}

export interface MethodIntentResponse {
  clientSecret: string;
  setupIntentId: string;
}

const routeRoot = 'payment-methods';

export async function listPaymentMethods(): Promise<PaymentMethodListItem[]> {
  return await api
    .get(routeRoot, {
      credentials: 'include',
    })
    .json<PaymentMethodListItem[]>();
}

export async function paymentMethodExists(paymentMethodId: string): Promise<PaymentMethodExistsResponse> {
  return await api
    .get(`${routeRoot}/${paymentMethodId}/exists`, {
      credentials: 'include',
    })
    .json<PaymentMethodExistsResponse>();
}

export async function toggleAutopayMethod(request: AutopayToggleRequest) {
  await api.put(`${routeRoot}/${request.paymentMethodId}/autopay-method`, {
    json: { isAutopay: request.isAutopay },
    credentials: 'include',
  });
}

export async function deletePaymentMethod(paymentMethodId: string) {
  await api.delete(`${routeRoot}/${paymentMethodId}`, { credentials: 'include' });
}

export async function createPaymentMethodIntent() {
  return await api
    .post(`${routeRoot}/method-intent`, {
      json: {},
      credentials: 'include',
    })
    .json<MethodIntentResponse>();
}

export async function updatePaymentMethodIntent({ setupIntentId, isAutopay, paymentMethodId }: MethodIntentUpdateRequest) {
  await api.put(`${routeRoot}/method-intent/${setupIntentId}`, {
    json: { isAutopay, paymentMethodId },
    credentials: 'include',
  });
}
